/**
 * Wire ↔ domain mappers for Dashboard Configuration.
 */

import type {
  DashboardResponse,
  DashboardToggleBody,
  SubsidiaryDashboardToggleBody,
} from '../types/dashboard-configuration.api.types';
import type {
  AdminDashboard,
  DashboardToggleRequest,
  SubsidiaryDashboardToggleRequest,
} from '../types/dashboard-configuration.types';

/** Wire → domain for a single admin-gated dashboard row. */
export function toAdminDashboard(wire: DashboardResponse): AdminDashboard {
  return {
    id: wire.id,
    key: wire.key,
    name: wire.name,
    description: wire.description,
    icon: wire.icon,
    sortOrder: wire.sort_order,
    enabled: wire.enabled,
    lastModifiedAt: wire.last_modified_at,
    lastModifiedBy: wire.last_modified_by,
    isOverride: wire.is_override ?? false,
  };
}

/** Domain → wire for a per-dashboard toggle PUT. */
export function toDashboardToggleBody(domain: DashboardToggleRequest): DashboardToggleBody {
  return {
    enabled: domain.enabled,
    modified_by: domain.modifiedBy,
  };
}

/** Domain → wire for a subsidiary dashboard override PUT. `reason` is only
 *  included when provided — omitted (not sent as `undefined`) otherwise. */
export function toSubsidiaryDashboardToggleBody(
  domain: SubsidiaryDashboardToggleRequest,
): SubsidiaryDashboardToggleBody {
  return {
    enabled: domain.enabled,
    ...(domain.reason ? { reason: domain.reason } : {}),
    user_id: domain.userId,
    user_name: domain.userName,
  };
}
